import { Button, message, Space, Table } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import SettingsProgLicense from "./settings-prog-license";

const SettingsProgLicenses = ({ progId }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState(null);

  const getData = () => {
    if (!progId) return;
    setLoading(true);
    serverFetch(`dict/license?idProg=${progId}`)
      .then((data) => {
        setLoading(false);
        setItems(data);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(() => {
    if (progId) getData();
  }, [progId]);

  const handleAdd = () => {
    setSelectedLicense({ licenseId: null });
  };

  const handleEdit = (record) => {
    setSelectedLicense({ licenseId: record.idLic });
  };

  const handleLicenseClose = (refresh) => {
    setSelectedLicense(null);
    if (refresh) {
      getData();
    }
  };
  
  const columns = [
    { dataIndex: "idLic", title: "#", width: 60 },
    {
      dataIndex: "name",
      title: "Название",
      render: (text, record) => (
        <span onClick={() => handleEdit(record)} style={{ cursor: "pointer", color: "#1890ff" }}>
          {text}
        </span>
      ),
    },
    { dataIndex: "komment", title: "Комментарий" },
  ];

  return (
    <div style={{ maxWidth: "80%" }}>
      <Space style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={handleAdd}>Добавить</Button>
        <Button onClick={getData} loading={loading}>Обновить</Button>
      </Space>
      <Table
        columns={columns}
        dataSource={items}
        loading={loading}
        rowKey="id"
        pagination={false}
        size="small"
        onRow={(record) => ({
          onClick: () => handleEdit(record),
          style: { cursor: 'pointer' }
        })}
      />

      {selectedLicense && (
        <SettingsProgLicense
          progId={progId}
          licenseId={selectedLicense.licenseId}
          visible={true}
          onClose={handleLicenseClose}
        />
      )}
    </div>
  );
};

export default SettingsProgLicenses;